import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,[_c(VCardTitle,{attrs:{"primary-title":""}},[_vm._v(" Notificación ")]),_c('div',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.tokenFirebase))]),_c('br'),_c('br'),_c('br'),_c(VCardActions,{staticClass:"ml-2"},[_c(VBtn,{attrs:{"color":"primary","rounded":""},on:{"click":function($event){return _vm.initialize( )}}},[_vm._v("iniciar")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }